import { Form, Input, Button, Checkbox, Image, Spin, message } from 'antd';
import React, { useState } from "react";
import logo from '../logo.png'
import PropTypes from 'prop-types';
import { useCookies } from 'react-cookie';
import axios from 'axios';
async function loginUser(credentials) {
  return axios.post('https://activatewm.com/v1/license/checkclient',credentials)
    .then(data => data)
    .catch(err=>{
      return null
    }
      )
 }
 
const Login=({setToken})=>{
    const [cookies,setCookie]=useCookies(['user'])
    const [loading,setLoading]=useState(false)
    const onFinish =async (values) => {
        setLoading(true)
        const token = await loginUser({
          license_code:values.code,        
        });

        if(token && token.data.status){
          
          let data=token.data.data
          console.log(data)
          if(!data.expire_status){
            setLoading(false)
            message.info('User been disabled by Admin')
            return
          }
          setCookie('code',data.code,{ path: '/' })
          setCookie('license_name',data.license_name,{ path: '/' })
          setCookie('customer_id',data.customer_id,{ path: '/' })
          setCookie('expire_date',data.expire_date,{ path: '/' })
          message.success('license activated successfully')
          setToken(data.customer_id);
        }else{
          console.log(token)
          setLoading(false)
          message.error('please check credentials')
        }
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
    
    return(
       <div className='log-cont '>
           
           <div className='log-form w3-card'>
           <Spin tip='Authenticating please wait' size='large' spinning={loading}>  
           <Image
      src={logo}
    />  
           <Form
           labelCol={{ span: 8 }}
              name="basic"
              onFinish={(values)=>{
                console.log(values)
                onFinish(values)
              }}
              onFinishFailed={onFinishFailed}
              
            >
              <Form.Item
                label="License Code"
                name="code"
                
                rules={[
                  {
                    required: true,
                    message: 'Please input your License Code!',
                    type:'string'
                  },
                ]}
              >
                <Input  />
              </Form.Item>
        
            
              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 10,
                }}
              >
                <Button type="primary" className='btn ant-form-item-control-input' htmlType="submit">
                  Login To Portal
                </Button>
              </Form.Item>
            </Form>
            </Spin>
           </div>
           
       </div>
           
           
    )
} 

export default Login
Login.propTypes = {
  setToken: PropTypes.func.isRequired
};